<nz-card [nzTitle]="mouldLogHeader">
  <ng-container *ngIf="error$ | async as errorMsg; else mouldLogsTemplate">
    <em-error-result [subTitle]="errorMsg"></em-error-result>
  </ng-container>

  <ng-template #mouldLogHeader>
    <em-mould-log-overview></em-mould-log-overview>
  </ng-template>
</nz-card>

<ng-template #longTextTemplate let-longText>
  <pre>{{ longText }}</pre>
</ng-template>

<ng-template #mouldLogsTemplate>
  <nz-skeleton [nzActive]="true" [nzLoading]="(isEquipmentLoading$ | async) ?? false">
    <div nz-row nzJustify="space-between" nzAlign="middle">
      <nz-select
        nz-col
        class="entry-code-filter"
        [nzLoading]="areEntryCodesLoading"
        nzMode="multiple"
        [nzAllowClear]="true"
        [nzShowSearch]="true"
        [nzFilterOption]="entryCodeFilter"
        [formControl]="entryCodesControl"
        nzPlaceHolder="Filter on codes"
      >
        <nz-option
          nzCustomContent
          *ngFor="let option of entryCodes$ | async; trackBy: trackByRef"
          [nzLabel]="option.code"
          [nzValue]="option"
        >
          <div>{{ option.code }} - {{ option.text }}</div>
        </nz-option>
      </nz-select>
    </div>

    <nz-divider></nz-divider>

    <nz-table
      #mouldLogTable
      [nzData]="(pagination$ | async)?.data ?? []"
      [nzLoading]="(paginatorRef.loading$ | async) ?? false"
      [nzFrontPagination]="false"
      [nzPageSizeOptions]="[5, 10, 20, 30]"
      nzSize="small"
      [nzPageSize]="perPage"
      [nzPageIndex]="pageIndex"
      (nzPageSizeChange)="pageSizeChange($event)"
      (nzPageIndexChange)="paginatorRef.setPage($event)"
      nzShowSizeChanger
      [nzTotal]="(pagination$ | async)?.total ?? 0"
    >
      <thead>
        <tr>
          <th>Log date</th>
          <th>Code</th>
          <th>Status text</th>
          <th>Short text</th>
          <th>User</th>
          <th>Long text</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let mouldLog of mouldLogTable.data; trackBy: trackByRef">
          <td>
            <em-display-property
              [value]="(mouldLog.logDate | date: 'shortDate') ?? ''"
            ></em-display-property>
          </td>
          <td><em-display-property [value]="mouldLog.codeNumber"></em-display-property></td>
          <td><em-display-property [value]="mouldLog.statusText"></em-display-property></td>
          <td><em-display-property [value]="mouldLog.shortText"></em-display-property></td>
          <td><em-display-property [value]="mouldLog.user"></em-display-property></td>
          <td>
            <button
              *ngIf="mouldLog.hasLongText"
              (click)="showLongText(mouldLog.longText)"
              nz-button
              nzType="link"
            >
              <i nz-icon nzType="file-text" nzTheme="twotone" nzTwotoneColor="5914fa"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-skeleton>
</ng-template>
